import React, { useId } from 'react'

// Inline SVG flags (emoji flags don't render on Windows). All share a 3:2 box.
const Frame = ({ children, viewBox = '0 0 3 2' }) => (
    <svg className="flag" viewBox={viewBox} width="24" height="16" preserveAspectRatio="none" aria-hidden="true">
        {children}
    </svg>
)

const UK = () => {
    const id = useId().replace(/:/g, '')
    return (
        <Frame viewBox="0 0 60 30">
            <clipPath id={`uk-s-${id}`}><path d="M0,0 v30 h60 v-30 z" /></clipPath>
            <clipPath id={`uk-t-${id}`}><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" /></clipPath>
            <g clipPath={`url(#uk-s-${id})`}>
                <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
                <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
                <path d="M0,0 L60,30 M60,0 L0,30" clipPath={`url(#uk-t-${id})`} stroke="#C8102E" strokeWidth="4" />
                <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
                <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
            </g>
        </Frame>
    )
}

const Spain = () => (
    <Frame viewBox="0 0 4 4">
        <rect width="4" height="4" fill="#AA151B" />
        <rect y="1" width="4" height="2" fill="#F1BF00" />
    </Frame>
)

const Germany = () => (
    <Frame viewBox="0 0 5 3">
        <rect width="5" height="1" fill="#000" />
        <rect y="1" width="5" height="1" fill="#DD0000" />
        <rect y="2" width="5" height="1" fill="#FFCE00" />
    </Frame>
)

const France = () => (
    <Frame>
        <rect width="1" height="2" fill="#002654" />
        <rect x="1" width="1" height="2" fill="#fff" />
        <rect x="2" width="1" height="2" fill="#CE1126" />
    </Frame>
)

const Italy = () => (
    <Frame>
        <rect width="1" height="2" fill="#009246" />
        <rect x="1" width="1" height="2" fill="#fff" />
        <rect x="2" width="1" height="2" fill="#CE2B37" />
    </Frame>
)

export const FLAGS = { en: UK, es: Spain, de: Germany, fr: France, it: Italy }
